interface DownloadCTAProps {
  onDownload: () => void;
}

export default function DownloadCTA({ onDownload }: DownloadCTAProps) {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="relative mx-auto w-full max-w-[1240px] overflow-hidden rounded-lg">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20stylized%20dark%20abstract%20banner%20artwork%20of%20a%20closed%20archive%20vault%20with%20faint%20crimson%20and%20warm%20amber%20light%20seams%20on%20a%20deep%20charcoal%20background%2C%20cinematic%20film%20grain%2C%20moody%20atmospheric%20lighting%2C%20high%20detail%2C%20no%20text%2C%20consistent%20collection%20visual%20style&width=1600&height=600&seq=hnb-cta-01&orientation=landscape"
            alt="黑网爆料 完整线索包下载入口背景"
            title="下载完整线索 暗网流出 暗网线索"
            className="h-full w-full object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/40"></div>
        </div>

        <div className="relative w-full px-6 py-14 md:px-12 md:py-16">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/60 bg-accent-500/15 px-3 py-1 text-xs text-accent-100">
              <i className="ri-folder-download-line"></i>
              资料入口 · 更醒目
            </span>
            <h2 className="mt-5 text-2xl font-bold leading-snug tracking-tight text-background-50 md:text-4xl">
              下载完整线索包，把截图与线索一次带走
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
              按主题打包的暗网截图、网络信息与隐藏线索索引，包含来源标注与对照结果，适合离线逐条核对。
              本页为静态展示，入口仅示意资料结构，不提供真实文件传输。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <button
                type="button"
                onClick={onDownload}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 cursor-pointer"
              >
                <i className="ri-download-2-line text-base"></i>
                立即下载线索包
              </button>
              <a
                href="#collections"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:border-background-50 cursor-pointer"
              >
                <i className="ri-layout-grid-line text-base"></i>
                先看资料结构
              </a>
            </div>

            <ul className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-xs text-background-200">
              <li className="inline-flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                含来源与抓取时间标注
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                原始片段与整理结果对照
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                随更新动态同步版本
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}